import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL


export const addNewRtoAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser")) 
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    
    const response = await axios.post(`${apiBaseUrl}/superAdmin/AddNewRTO`, formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error adding New RTO:", error);
    throw error;
  }
}